export default ({
  namespaced: true,
  state: {
    view: 'system',
    // type: 'index',
    values: []
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      Object.assign(state.values, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/system.js